import React, {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals, formatPrice } from 'helpers'
import Media from 'local_modules/Media'

import Box from 'components/layout/Box/Box'
import Modal from 'components/Modal/Modal'
import Button from 'components/ui/Button/Button'
import { Grid, Cell } from 'components/layout/grid'
import WidthContainer from 'components/WidthContainer/WidthContainer'

import s from './AddCatalogModal.scss'


class AddCatalogModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.AddCatalog,
  }

  close = () => {
    const { name } = this.props

    actions.modals.close(name)
  }

  render() {
    const { data: { categories, onSelect } } = this.props

    return (
      <Modal className={s.modal} onClose={this.close}>
        <WidthContainer>
          <div className={s.title}>Добавить позицию</div>
          {/*<div className={s.text}>{text}</div>*/}
          <Media desktop>
            {
              (isDesktop) => (
                <Fragment>
                  {
                    categories.map(({ id, img, title, price, description, ...rest }) => (
                      <Box key={id} pt="sm">
                        <Grid className={s.grid} columns={isDesktop ? 7 : 6} gutter="md">
                          <Cell size={isDesktop ? 7 : 6}>
                            <Box pt="sm">
                              <b>{title}</b>
                            </Box>
                          </Cell>
                          <Cell size={isDesktop ? 1 : 2} center>
                            {
                              Boolean(img) && (
                                <img className={s.image} src={`data:image/jpeg;base64,${img}`} />
                              )
                            }
                          </Cell>
                          <Cell size={isDesktop ? 3 : 4} center>
                            <div
                              style={{ width: '100%' }}
                              dangerouslySetInnerHTML={{ __html: description.replace(/\n/g, '<br />') }}
                            />
                          </Cell>
                          <Cell size={isDesktop ? 1 : 3} center>
                            {formatPrice(price, true, true)}
                          </Cell>
                          <Cell size={isDesktop ? 2 : 3} center>
                            <Button
                              title="Выбрать"
                              size="md"
                              green
                              fullWidth
                              onClick={() => {
                                onSelect({ id, img, title, price, description, ...rest })
                                this.close()
                              }}
                            />
                          </Cell>
                        </Grid>
                      </Box>
                    ))
                  }
                </Fragment>
              )
            }
          </Media>
          <div style={{ height: '120px' }} />
        </WidthContainer>
      </Modal>
    )
  }
}


export default AddCatalogModal